import React from "react";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";
import { colors } from "UI/colors";

export default function SetupComplete() {
  return (
    <Wrapper>
      <Content>
        <Title>You did it! Let&apos;s start fundraising! 🎉</Title>

        {/* <Description>
          Not sure what to do next? Click the button below to be taken to our
          handy setup steps!
        </Description> */}
      </Content>

      {/* <ButtonWrapper>
        <FnrButton
          onClick={() => window.fnReactBus.goToUrl("/fundit")}
          color={colors.fnYellow}
          size="large"
          data-cy="stax-signup-setup-complete-button"
        >
          Take me there!
        </FnrButton>
      </ButtonWrapper> */}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 5px;
`;

const Content = styled.div`
  text-align: center;
  color: ${colors.fnDkBlue};
`;

const Title = styled.div`
  color: white;
  font-weight: 600;
  font-size: 21px;
`;

const Description = styled.div`
  font-size: 16px;
  margin-top: 8px;
  font-weight: 400;
`;

const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
`;
